import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import AOS from 'aos';
import FullCalendar from '@fullcalendar/react';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import listPlugin from '@fullcalendar/list';
import AvatarDefault from './default-avatar.png';
import 'aos/dist/aos.css';
import './home.css';
import { UsersService } from '../../services/user';
import $ from "jquery";

import {
  Header,
  Categories,
  Card,
  Menu,
  CoinsAndBadges,
  Webview,
  OfflineTooltip,
  OfflineMessageView
} from '../../components';
import { Utils } from '../../utils/utils';
export default class ViewHome extends Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();
    this.customizedRef = React.createRef();

    this.state = {
      "render_coins_and_badges": false,
      "coins": null,
      "courses": null,
      "user": null,
      "active_project": null,
      "customization": null,
      "active_tab": "study",
      "events": null,
      "posts": null,
      "selected_blog_post": null,
      "dates_expanded_list": [Utils.localeDate(new Date())],
      "avatarFile": null,
      "avatarUrl": null,
      "optative_disciplines_expanded": false
    }

    this.onUpdateProfile = this.onUpdateProfile.bind(this);
  }

  componentWillMount() {
    this.redirectToTab();
    this.getUser();
    this.getCourses();
    AOS.init({
      // anchorPlacement: 'top-bottom'
      offset: -50
    });
    this.setState({
      "active_tab": this.getRole().graduacao ? "study" : "courses"
    })
  }

  getRole() {
    var roles = Sdk.Api.authorization.user.roles;

    return {
      "graduacao": roles.filter(role => role.type === "Viewer").length > 0,
      "cursos_livres": roles.filter(role => role.type === "LearningViewer").length > 0
    }
  }

  redirectToTab() {
    var tab = Utils.getUrlParam("tab");
    if (tab !== null) {
      this.setState({
        "active_tab": tab
      })
    }
  }

  startAutoScroll() {
    setTimeout(() => {
      const container = document.querySelector('.rdp-react-template-view-home-content');
      const elementHeaders = document.getElementsByClassName('fc-list-day');
      const header = document.querySelector('.rdp-react-template-component-header');
      const menu = document.querySelector('.rdp-react-template-component-categories');

      const day = new Date().getDay();
      
      if (elementHeaders && container && header && menu) {
        const currentHeader = elementHeaders[day - 1];
        if (currentHeader) {
          const currentHeaderRect = currentHeader.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const targetPosition = currentHeaderRect.top - containerRect.top
          const discount = header.clientHeight + menu.clientHeight
          container.scrollBy(0, (targetPosition - discount) + 40);
        }
      }
    }, 500)
  }

  componentDidMount() {
    this.updateDownloadProgress();
  }

  toggleShowEvents(dateCompare, hidden = true) {
    const _this = this;
    const { events } = this.state;

    _this.setState({ 
      events: events.map(item => {
        const dateStart = Utils.parseDateString(item.start);
        const start = Utils.localeDate(dateStart);
        if (start === dateCompare) {
          return { ...item, hidden: hidden }
        }
        return item;
      }),
    })
  };

  refreshCustomizationWhenNaviationWeek() {
    const _this = this;
    const buttonsToolbar = document.getElementsByClassName('fc-button-group');
    const [prev, next] = Array.from(buttonsToolbar);

    try {
      (prev || next).onclick = () => {
        _this.customizeCalendar();
      }
    } catch (e) {

    }
  }

  customizeCalendar() {
    const _this = this;
    if (this.state.active_tab === "study") {
     const elements = document.getElementsByClassName('fc-list-day-side-text');
     const elementHeaders = document.getElementsByClassName('fc-list-day');
      
     const chevronIconHtml = `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 14a.997.997 0 01-.707-.293l-5-5a.999.999 0 111.414-1.414L10 11.586l4.293-4.293a.999.999 0 111.414 1.414l-5 5A.997.997 0 0110 14z" fill="#fff"/></svg>`
      
     Array.from(elements).forEach((element, i) => {
      const stringDate = element.innerText;
      const chevron = document.createElement('span');

      element.style.display = 'flex';
      element.style.marginBottom = "-4px";
      chevron.style.transition = "0.5s";
      chevron.style.marginLeft = "10px";
      chevron.style.marginTop = "-2px";

      chevron.classList.add("react-chevron-icon-down");
      chevron.innerHTML = chevronIconHtml;
      const dateFrom = Utils.parseDateString(stringDate);
      const toDate = Utils.localeDate(dateFrom);

      const eventInitExpanded = _this.state.events.find(item => {
        var itemStart = item.start;
        if (typeof itemStart === "string") itemStart = new Date(itemStart);
        const start = Utils.localeDate(itemStart);
        return start === toDate;
      });

      if (eventInitExpanded && eventInitExpanded.hidden === false) {
        chevron.classList.toggle("expanded");
        chevron.style.transform = "rotate(180deg)";
      };

      elementHeaders[i].onclick = () => {
        if (chevron.classList.contains("expanded")) {
          chevron.style.transform = "rotate(0)";
          _this.toggleShowEvents(toDate, true);
        }

        else {
          chevron.style.transform = "rotate(180deg)";
          _this.toggleShowEvents(toDate, false);
        }
        chevron.classList.toggle("expanded")
      };
      
      element.appendChild(chevron);
     })
    }
  }

  componentDidUpdate() {
    if(this.state.events && !this.customizedRef.current) {
      this.customizedRef.current = true;
      this.setState({ events: this.state.events.map(item => {
        const start = Utils.localeDate(item.start);
        const today = Utils.localeDate(new Date());
        return {
          ...item,
          hidden: start !== today,
        }
      })}, () => {
        this.customizeCalendar();
        this.refreshCustomizationWhenNaviationWeek();
        this.startAutoScroll();
      })
    }
  }

  componentWillUnmount() {
    var _this = this;
    window.document.removeEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
  }

  updateDownloadProgress() {
    var _this = this;
    window.document.addEventListener("courseDownloadedUpdated", _this.handleCourseDownloadedUpdated);
  }

  handleCourseDownloadedUpdated(event) {
    this.getNodes(this.state.courses);
    const { uid } = event.detail;
  }

  async signOut() {
    await UsersService.signOut()
    this.props.history.replace('/');
  }

  async getUser() {
    // var userDetails = await UsersService.getUserDetails();
    var userDetails, avatar;
    
    if (Utils.recoverBridge(`/auth/v1.0/user/me`) !== null) {
      userDetails = Utils.recoverBridge(`/auth/v1.0/user/me`);
      avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);

      this.setState({
        "user": {
          ...(userDetails || {}),
          avatar,
        }
      });
    }
    
    userDetails = await Utils.bridgeAndStore(`/auth/v1.0/user/me`, null, 'GET');

    // var userDetails = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    if (userDetails.detail.name.search("Guest") > -1) {
      this.signOut();
    }
    avatar = Sdk.Api.dynamic.bridgeUrl(`/auth/v1.1/user/uid/${(userDetails || {}).uid}/thumb`);
    // this.setActiveProject(userDetails.projects);

    this.setState({
      "user": {
        ...(userDetails || {}),
        avatar,
      }
    });
  }

  setActiveProject(projects) {
    var activeProjectUid = UsersService.getActiveProjectUid();

    if (activeProjectUid !== null) {
      var activeProject = projects.find(project => project.uid === activeProjectUid);
      this.setState({
        "active_project": activeProject
      });

      this.setCustomization(activeProject)
    };
  }

  async setCustomization(activeProject) {
    var customizationConnector = activeProject.connectors.find(connector => connector.type === "Customization_1");
    
    if (window.localStorage.getItem(`connector-${customizationConnector.uid}`)) {
      this.setState({
        "customization": JSON.parse(window.localStorage.getItem(`connector-${customizationConnector.uid}`)).configuration.configs
      });
    };

    if (customizationConnector !== undefined) {
      var connector = await UsersService.getConnector(customizationConnector.uid);
      this.setState({
        "customization": connector.configuration.configs
      });
    }
  }

  async getCourses() {
    // var courses = await UsersService.getCourses();
    var courses, nodes;
    if (Utils.recoverBridge(`/cms/v1.1/learning/courses?page_size=500`) !== null) {
      courses = Utils.recoverBridge(`/cms/v1.1/learning/courses?page_size=500`);
      courses.result = courses.result.filter(course => course.access_status !== "Blocked");
      nodes = await this.getNodes(courses.result);
    };

    courses = await Utils.bridgeAndStore(`/cms/v1.1/learning/courses?page_size=500`, null, 'GET');
    courses.result = courses.result.filter(course => course.access_status !== "Blocked");
    nodes = await this.getNodes(courses.result);
    // this.setState({
    //   "courses": courses.result
    // });
  }

  createNodesEventsWithDates(nodes, overrides, courseStatus, course) {
    var events = [];
    var statusActivities = courseStatus.activities;

    for (var i = 0; i < nodes.length; i++) {
      var childs = nodes[i].childs;
      for (var j = 0; j < overrides.length; j++) {
        for (var k = 0; k < childs.length; k++) {
          var activities = childs[k].activities;
          for (var l = 0; l < activities.length; l++) {
            for (var m = 0; m < statusActivities.length; m++) {
              if (activities[l].uid === statusActivities[m].uid) {
                activities[l].status = statusActivities[m].status;
                if (statusActivities[m].local_storage) {
                  activities[l].local_storage = statusActivities[m].local_storage;
                };
              };
            };
          };

          if (childs[k].uid === overrides[j].uid) {
            childs[k].interaction_start = overrides[j].interaction_start;
            childs[k].parent_title = nodes[i].data.title;
            nodes[i].hasLessons = true;

            events.push({
              "title": childs[k].data.title,
              "start": new Date(overrides[j].interaction_start),
              "extendedProps": {
                "title": childs[k].data.title,
                "parent_title": nodes[i].data.title,
                "activities": activities,
                "course_uid": course.course.uid,
                "course_title": course.course.title,
                "register_uid": course.register.uid,
                "module_uid": nodes[i].uid,
                "is_past_date": new Date(overrides[j].interaction_start).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
              }
            })
            // "/player/:courseUid/:registerUid/:moduleUid/:activityUid"
          };
        };
      };
    };

    return events;
  }

  injectCourseDownloadProgress(activities) {
    var downloading = [];
    var downloaded = [];

    for (var i = 0; i < activities.length; i++) {
      if (activities[i].local_storage) {
        if (activities[i].local_storage.state === "Downloading") {
          downloading.push(activities[i]);
        };
        if (activities[i].local_storage.state === "Downloaded") {
          downloaded.push(activities[i]);
        };
      };
    };

    return downloaded.length / activities.length * 100;
  }

  uniqueEvents(events) {
    let setObj = new Set(events.map(JSON.stringify));
    let output = Array.from(setObj).map(JSON.parse);
    
    return output;
  }

  async getNodes(courses) {
    var _this = this;

    var events = [];

    for (var i = 0; i < courses.length; i++) {
      var registerUid = courses[i].register.uid;
      var courseStatus = null;
      var courseTree = null;

      if (Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`) !== null) {
        courseStatus = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/status`);
      };
  
      if (Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`) !== null) {
        courseTree = Utils.recoverBridge(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`);
      };

      if (courseStatus !== null && courseTree !== null) {
        var overrides = courseStatus.nodes.filter(node => node.interaction_start !== null)
        courses[i].progress = _this.injectCourseDownloadProgress(courseStatus.activities);
        events = events.concat(_this.createNodesEventsWithDates(courseTree, overrides, courseStatus, courses[i]));
      }

      this.setState({
        "courses": courses,
        "events": events
      })
    }

    for (var i = 0; i < courses.length; i++) {
      var registerUid = courses[i].register.uid;
      var courseStatus = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/status`, null, 'GET');
      var courseTree = await Utils.bridgeAndStore(`/cms/v1.0/learning/register/uid/${registerUid}/nodes/tree`, null, 'GET');
      var overrides = courseStatus.nodes.filter(node => node.interaction_start !== null)
      courses[i].progress = _this.injectCourseDownloadProgress(courseStatus.activities);
      events = events.concat(_this.createNodesEventsWithDates(courseTree, overrides, courseStatus, courses[i]));
    }

    this.setState({
      "courses": courses,
      "events": this.uniqueEvents(events)
    })
  }

  formatCoins(numb) {
    return numb.toLocaleString('pt-br');
  }

  onClick(type, uid) {
    this.props.history.push('/' + type + '/' + uid);
  }

  onCoinsClick() {
    this.setState({
      "render_coins_and_badges": true
    })
  }

  onCourseClick(courseUid, registerUid) {
    this.props.history.push('/curso/' + courseUid + '/' + registerUid);
  }

  getCustomizationConfig(uid, prop) {
    var config = null;
    var customization = this.state.customization;

    if (customization) {
      config = JSON.parse(customization.find(item => item.uid === uid).value).find(obj => obj.uid === prop).value;
    }

    return config;
  }

  getProgress(course) {
    return Math.round(course.activities.total_status_completed / course.activities.total_activities * 100)
  }

  onActivityClick(courseUid, registerUid, moduleUid, activityUid) {
    this.props.history.push('/player/' + courseUid + '/' + registerUid + '/' + moduleUid + '/' + activityUid);
  }

  downloadedActivity(activity) {
    var isDownloaded = false;

    if (activity.local_storage && activity.local_storage.state === "Downloaded") {
      isDownloaded = true;
    };

    return isDownloaded;
  }

  renderIcon(name) {
    if (name.search("Conteúdo WEB") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon conteudo-web"></span>
    } else if (name.search("Leitura:") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon leitura"></span>
    } else if (name.search("Avaliação Final") > -1 || name.search("Avaliação Virtual") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon prova-presencial"></span>
    } else if (name.search("Teleaula:") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon teleaula"></span>
    } else if (name.search("Live:") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon live"></span>
    } else if (name.search("Engajamento AVA:") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon engajamento-ava"></span>
    } else if (name.search("Prova Presencial da Disciplina") > -1) {
      return <span className="rdp-react-template-view-home-calendar-activity-icon prova-presencial"></span>
    }
    
  }

  renderEventContent(eventInfo) {
    var _this = this;
    // "extendedProps": {
    //   "title": childs[k].data.title,
    //   "parent_title": nodes[i].data.title,
    //   "activities": activities,
    //   "course_uid": course.uid,
    //   "register_uid": course.register.uid,
    //   "module_uid": nodes[i].uid
    //   "is_past_date": true
    // }
    // })
    // "/player/:courseUid/:registerUid/:moduleUid/:activityUid"

    const {
      title,
      parent_title,
      activities,
      course_uid,
      course_title,
      register_uid,
      module_uid,
      is_past_date,
      hidden
    } = eventInfo.event.extendedProps;

    if (hidden) return;

    return <div className="rdp-react-template-view-home-calendar-item">
      {activities.filter(act => act.status === "Completed").length === activities.length &&
        <span className="rdp-react-template-view-home-calendar-item-status-icon success"></span>
      }
      {is_past_date && (activities.filter(act => act.status === "Completed").length < activities.length) &&
        <span className="rdp-react-template-view-home-calendar-item-status-icon warning"></span>
      }
      {!is_past_date && (activities.filter(act => act.status === "Completed").length < activities.length) &&
        <span className="rdp-react-template-view-home-calendar-item-status-icon clock"></span>
      }
      {/* <span className="rdp-react-template-view-home-calendar-item-name">{parent_title} / {title}</span> */}
      <span className="rdp-react-template-view-home-calendar-course-title">Disciplina: {course_title}</span>
      <span className="rdp-react-template-view-home-calendar-item-name">{parent_title}</span>
      <span className="rdp-react-template-view-home-calendar-item-subname">{title}</span>
      <ul className="rdp-react-template-view-home-calendar-activities">
        {activities && activities.map(function (activity, index) {
          return <li key={index} onClick={() => _this.onActivityClick(course_uid, register_uid, module_uid, activity.uid)} className={`rdp-react-template-view-home-calendar-activity ${_this.downloadedActivity(activity) ? "downloaded" : ""} ${activity.status} ${activities.length === (index + 1) ? "last" : ""}`}>
            {_this.renderIcon(activity.name)}
            <span className="rdp-react-template-view-home-calendar-activity-label">{activity.name}</span>
          </li>
        })}
      </ul>
    </div>
  }

  formatBlogDate(dat) {
    // var splited = dat.split("T")[0].split("-");
    // return `${splited[2]}/${splited[1]}/${splited[0]}`;
    return dat;
  }

  onBlogPostClick(url) {
    this.setState({
      "selected_blog_post": url
    })
  }

  async onUpdateProfile () {
    const { avatarFile, user } = this.state;
    const formData = new FormData();

    if (!avatarFile || !user) return;

    formData.append('profile', avatarFile);

    await Sdk.Api.dynamic.bridge(`/auth/v1.1/user/me/thumb`, formData, "PUT")
    .then(() => {
      this.setState({ 
        active_tab: 'study',
        user: { 
        ...user, avatar: URL.createObjectURL(avatarFile)
      }});
    })
    .catch(err => {
      console.log(err);
    })
  };

  redirectTo(path) {
    this.props.history.push(path);
  }

  optativeSubscription() {
    this.setState({
      "optative_disciplines_expanded": false
    });
    $(`[data-id="162f389d-a326-ef11-86d4-00224821ba75"`).show();
  }

  render() {
    var _this = this;
    const {
      user,
      courses,
      posts,
      customization,
      active_tab,
      selected_blog_post,
      dates_expanded_list,
      avatarFile,
      avatarUrl,
      optative_disciplines_expanded
    } = this.state;
    
    const { name, first_name, last_name } = (user || { detail: {}}).detail;

    return (<div className="rdp-react-template-view-home">
      {this.state.render_coins_and_badges &&
        <CoinsAndBadges
          onClose={() => this.setState({"render_coins_and_badges": false})}
        />
      }
      <div className="rdp-react-template-view-home-container">
        <Header
          onEditClick={() => {
            window.location.hash = 'perfil';
          }}
          name={user && user.detail && user.detail.name.split(" ")[0]}
          level="Nível 1"
          coins={this.state.coins}
          coinsLabel="BV Coins"
          onCoinsClick={() => this.onCoinsClick()}
          avatar={user && user.avatar ? user.avatar : undefined}
        />
        <Categories
          page="feed"
          active={active_tab}
          onTabClick={(tab) => {
            this.setState({"active_tab": tab}, () => {
              if (tab === 'study' && active_tab !== 'study') {
                this.startAutoScroll();
                this.customizeCalendar();
                this.refreshCustomizationWhenNaviationWeek()
              };
            })
          }}
        />
        <OfflineTooltip/>

        {active_tab === 'edit_perfil' && (
           <div className="rdp-react-template-view-home-content">
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
              <div className="rdp-react-template-view-home-perfil-content">
                <label htmlFor="chage-profile-input">
                  <img 
                    src={avatarFile ? URL.createObjectURL(avatarFile) : user.avatar ? user.avatar : undefined} 
                    alt="user-profile"
                    onLoad={e => {
                      URL.revokeObjectURL(e.target.src)
                    }}
                    // onError={e => e.target.src = AvatarDefault}
                  />
                </label>
                <input 
                  onChange={e => {
                    if (e.target.files) {
                      const [file] = e.target.files
                      this.setState({ 
                        avatarFile: e.target.files[0],
                        avatarUrl: window.URL.createObjectURL(file)
                      })
                    }
                  }}
                  type="file" 
                  hidden 
                  id="chage-profile-input" 
                />
                <input placeholder="Nome" value={first_name || (name || '').split(' ')[0]} />
                <input placeholder="Sobrenome" value={last_name || (name || '').split(' ')[1]} />
                <button onClick={this.onUpdateProfile}>Salvar</button>
              </div>
            </div>
           </div>
        )}
        {active_tab === "study" &&
          <div className="rdp-react-template-view-home-content">
            {this.state.events === null &&
              <div className="rdp-react-template-view-login-preloader">
                <div className="rdp-react-template-view-login-preloader-loader"></div>
              </div>
            }
            {this.state.events &&
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
                <FullCalendar
                  locale={ptBrLocale}
                  plugins={[listPlugin]}
                  initialView='listWeek'
                  weekends={false}
                  events={this.state.events}
                  eventContent={(e) => this.renderEventContent(e)}
                />
              </div>
            }
          </div>
        }
        {active_tab === "courses" &&
          <div className="rdp-react-template-view-home-content">
            {courses === null &&
              <div className="rdp-react-template-view-login-preloader">
                <div className="rdp-react-template-view-login-preloader-loader"></div>
              </div>
            }
            {/* {courses &&
              <div className="rdp-react-template-view-home-disciplinas-optativas">
                <h1 className="rdp-react-template-view-home-disciplinas-optativas-title">Disciplinas optativas</h1>
                <p className="rdp-react-template-view-home-disciplinas-optativas-message">
                  Você ainda não definiu as disciplinas optativas. Se matricule nas disciplinas de sua preferência clicando no botão abaixo:
                </p>
                <button className={`rdp-react-template-view-home-disciplinas-optativas-btn ${optative_disciplines_expanded ? "expanded" : ""}`} onClick={() => this.setState({"optative_disciplines_expanded": !this.state.optative_disciplines_expanded})}>
                  Visualizar disciplinas optativas
                </button>

                {optative_disciplines_expanded &&
                  <ul className="rdp-react-template-view-home-disciplinas-optativas-items">
                    <li className="rdp-react-template-view-home-disciplinas-optativas-item" onClick={() => this.optativeSubscription()}>
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-title">Cálculo Numérico</span>
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-btn">Realizar Inscrição</span>
                    </li>
                    <li className="rdp-react-template-view-home-disciplinas-optativas-item">
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-title">Simulação Empresarial</span>
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-btn">Realizar Inscrição</span>
                    </li>
                    <li className="rdp-react-template-view-home-disciplinas-optativas-item">
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-title">Gestão da Inovação</span>
                      <span className="rdp-react-template-view-home-disciplinas-optativas-item-btn">Realizar Inscrição</span>
                    </li>
                  </ul>
                }
              </div>
            } */}

            {courses && 
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
                {courses.map(function (course, index) {
                  return <Card
                    key={index}
                    uid={course.course.uid}
                    renderInfo={false}
                    type="course"
                    date={course.course.title}
                    title={course.course.title}
                    localization={course.course.description}
                    thumb={course.course.thumb_url}
                    onClick={() => _this.onCourseClick(course.course.uid, course.register.uid)}
                    progress={_this.getProgress(course)}
                    activitiesLabel={`${course.activities.total_status_completed} / ${course.activities.total_activities}`}
                    downloaded={course.progress}
                  />
                })}
              </div>
            }
          </div>
        }
        {active_tab === "em-alta" &&
          <div className="rdp-react-template-view-home-content">
            {posts === null &&
              <div className="rdp-react-template-view-login-preloader">
                <div className="rdp-react-template-view-login-preloader-loader"></div>
              </div>
            }
            {posts && 
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
                {posts.map(function (post, index) {
                  return <Card
                    key={index}
                    renderInfo={false}
                    type="blog"
                    date={post.title}
                    title={post.title}
                    localization={_this.formatBlogDate(post.date)}
                    thumb={post.cover}
                    onClick={() => _this.onBlogPostClick(post)}
                    customClassName="only-online"
                  />
                })}
              </div>
            }
            <OfflineMessageView message="Conecte seu dispositivo à internet para acessar os conteúdos Em Alta."/>
          </div>
        }
        {active_tab === "secretaria" &&
          <div className="rdp-react-template-view-home-content">
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500">
              <h2>Você está na Secretaria, como podemos te ajudar?</h2>
              <ul className="rdp-react-template-view-home-content-cards">
                <li className="rdp-react-template-view-home-content-card" onClick={() => this.redirectTo("secretaria/servicos-academicos")}>
                  <span className="rdp-react-template-view-home-content-card-icon cap"></span>
                  <span className="rdp-react-template-view-home-content-card-title">Serviços Acadêmicos</span>
                </li>
                <li className="rdp-react-template-view-home-content-card" onClick={() => this.redirectTo("secretaria/servicos-financeiros")}>
                  <span className="rdp-react-template-view-home-content-card-icon money"></span>
                  <span className="rdp-react-template-view-home-content-card-title">Serviços Financeiros</span>
                </li>
                <li className="rdp-react-template-view-home-content-card inactive">
                  <span className="rdp-react-template-view-home-content-card-icon document"></span>
                  <span className="rdp-react-template-view-home-content-card-title">Termos e Contratos</span>
                </li>
              </ul>

              <h2>Solicitações mais frequentes</h2>
              <ul className="rdp-react-template-view-home-content-cards">
                <li className="rdp-react-template-view-home-content-card orange" onClick={() => this.redirectTo("secretaria/servicos-academicos/carteirinha-digital")}>
                  <span className="rdp-react-template-view-home-content-card-title">Carteirinha Digital</span>
                </li>
                <li className="rdp-react-template-view-home-content-card orange" onClick={() => this.redirectTo("secretaria/servicos-financeiros/mensalidades-e-servicos")}>
                  <span className="rdp-react-template-view-home-content-card-title">Mensalidades e Serviços</span>
                </li>
                <li className="rdp-react-template-view-home-content-card orange" onClick={() => this.redirectTo("secretaria/servicos-academicos/atividades-complementares")}>
                  <span className="rdp-react-template-view-home-content-card-title">Atividades Complementares</span>
                </li>
              </ul>

              <h2>Dúvidas e Orientações</h2>
              <ul className="rdp-react-template-view-home-content-tags">
                <li className="rdp-react-template-view-home-content-tag">Atividade Complementar – ACO</li>
                <li className="rdp-react-template-view-home-content-tag">Principais Dúvidas e Orientações</li>
                <li className="rdp-react-template-view-home-content-tag">Diploma</li>
                <li className="rdp-react-template-view-home-content-tag">Colação de Grau</li>
                <li className="rdp-react-template-view-home-content-tag">Avaliação Continuada</li>
                <li className="rdp-react-template-view-home-content-tag">FAQ - Colação de Grau</li>
                <li className="rdp-react-template-view-home-content-tag">Trancamento e Cancelamento de Matrícula</li>
                <li className="rdp-react-template-view-home-content-tag">Parcelamentos - Matrícula Tardia</li>
                <li className="rdp-react-template-view-home-content-tag">ENADE</li>
                <li className="rdp-react-template-view-home-content-tag">Conheça a nossa nova home!</li>
              </ul>
            </div>
          </div>
        }
      </div>
      <Menu
        active="meu-curso"
      />

      {selected_blog_post &&
        <Webview
          title={selected_blog_post.title}
          url={selected_blog_post.link}
          onBack={() => {
            this.setState({"selected_blog_post": null})
          }}
        />
      }
    </div>);
  }
}
